import type { AnyAction } from "redux";
import * as actionTypes from "../../action_types/users_filters_selection_action_types";

function getDefaultState() {
    return {
        digitalSuiteSelectedWebSource: undefined,
        digitalSuiteSelectedCountry: undefined,
        digitalSuiteSelectedDuration: undefined,
        digitalSuiteOpenSelectedCountry: undefined,
        isNewSession: true,
    };
}

export function usersDigitalSuiteFiltersSelection(state = getDefaultState(), action: AnyAction) {
    switch (action.type) {
        case actionTypes.DIGITAL_SUITE_OPEN_COUNTRY_SELECTION: {
            return { ...state, digitalSuiteOpenSelectedCountry: action.selectedCountry };
        }
        case actionTypes.DIGITAL_SUITE_COUNTRY_SELECTION: {
            return { ...state, digitalSuiteSelectedCountry: action.selectedCountry };
        }
        case actionTypes.DIGITAL_SUITE_DURATION_SELECTION: {
            return { ...state, digitalSuiteSelectedDuration: action.selectedDuration };
        }
        case actionTypes.DIGITAL_SUITE_WEB_SOURCE_SELECTION: {
            return { ...state, digitalSuiteSelectedWebSource: action.selectedWebSource };
        }
        case actionTypes.IS_NEW_SESSION: {
            return { ...state, isNewSession: action.isNewSession };
        }
        default:
            return state;
    }
}
